import { styled } from '@f8n-frontend/stitches';

import { createClassSelector } from 'utils/styles';

const MULTI_BUTTON_CLASSNAME = 'multi-button';

const MULTI_BUTTON_SELECTOR = createClassSelector(MULTI_BUTTON_CLASSNAME);

const ContentBlockItemRoot = styled('div', {
  display: 'flex',
  position: 'relative',
  '@hover': {
    [MULTI_BUTTON_SELECTOR]: {
      opacity: 0,
      transition: 'opacity $2 $ease',
    },

    '&:hover': {
      [MULTI_BUTTON_SELECTOR]: {
        opacity: 1,
      },
    },
  },

  '@noHover': {
    [MULTI_BUTTON_SELECTOR]: {
      display: 'none',
    },
  },
});

const ContentBlockItemControls = styled('div', {
  position: 'absolute',
  right: '$2',
  top: '$2',
  display: 'flex',
  gap: '$1',
  zIndex: 1,
  height: '100%',
});

export const ContentBlockItem = {
  Root: ContentBlockItemRoot,
  Controls: ContentBlockItemControls,
  BUTTON_CLASSNAME: MULTI_BUTTON_CLASSNAME,
};
